import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShippingAddressComponent } from './shipping-address/shipping-address.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShippingStepsComponent } from './shipping-steps/shipping-steps.component';
import { ShippingSummaryComponent } from './shipping-summary/shipping-summary.component';
import { ShippingRoutingModule } from './shipping-routing.module';
import { ShippingOptionsComponent } from './shipping-options/shipping-options.component';
import { ShippingFinalComponent } from './shipping-final/shipping-final.component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { ShippingComponent } from './shipping.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


@NgModule({
  declarations: [
    ShippingAddressComponent,
    ShippingStepsComponent,
    ShippingSummaryComponent,
    ShippingOptionsComponent,
    ShippingFinalComponent,
    OrderConfirmationComponent,
    ShippingComponent
  ],
  imports: [
    CommonModule,
    ShippingRoutingModule,
    SharedModule,
    NgxIntlTelInputModule
  ],
  exports: [
    ShippingSummaryComponent
  ]
})
export class ShippingModule { }
